module.exports = __webpack_public_path__ + "annualreview2017/static/img/chi-tin-wan.344e473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/board/chi-tin-wan.jpg
// module id = 683
// module chunks = 0